import React from 'react';
import ReactDOM from 'react-dom';
import styles from './modal.css';
import closeIcon from './x.svg';

const CLASS_WRAPPER = '__react-modal-wrapper__';

const getRandom = (length) => {
  var length = length ? length : 5;
  var str = '';
  var chars ='abcdefghiklmnopqrstuvwxyz'.split(
      '');
  var charsLen = chars.length;
  if (!length) {
    length = ~~(Math.random() * charsLen);
  }
  for (var i = 0; i < length; i++) {
    str += chars[~~(Math.random() * charsLen)];
  }
  return str;
}

class Modal extends React.Component{
  constructor (props){
    super(props);

    this.remove = this.remove.bind(this);
  }

  remove(e){
    let _el = document.getElementById(this.props.dados.identifier);
    Modal.removeModal(_el);
    e.preventDefault();
  }

  static removeModal(_el){
    _el.classList.remove('in');
    document.body.classList.remove('__modal-open__');
    //delay para criar animação no elemento
    setTimeout(function(){
      ReactDOM.unmountComponentAtNode(_el);
      _el.remove();
    },300);
  }

  static destroy (){
    let boxes = document.getElementsByClassName(CLASS_WRAPPER);
    if(boxes){
      let el = boxes[0];
      let id = el.getAttribute('id');
      let _el = document.getElementById(id);
      Modal.removeModal(_el);
    }
  }

  static create (__args__ = {}){
    const container = document.createElement("div");
    var _randomId = getRandom(5);
    container.setAttribute("id", _randomId);
    container.setAttribute("class", CLASS_WRAPPER);
    document.body.appendChild(container);
    __args__.identifier = _randomId;

    if(__args__.classes){
      container.classList.add(__args__.classes);
    }

    document.body.classList.add('__modal-open__');

    var overlay = ReactDOM.render(<Modal dados={__args__} />,document.getElementById(_randomId));

    //delay para criar animação no elemento
    setTimeout(function(){
      container.classList.add('in');
    },10);

    return _randomId;
  }

  render() {
    const content = this.props.dados.content;
    const mainClass = '__react-modal__';

    return (
      <div className={mainClass}>
        <div className='__react-modal-wrapper__'>
          <div className='__react-modal-inner__'>
            <a href='#' onClick={this.remove} className='__react-modal-bt-close__'><img src={closeIcon} /></a>
            {content}
          </div>
        </div>
      </div>
    )
  };
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/modal.v2/Modal.js